import React from 'react'
import { levelitemProps } from './levelgroup-interface'

const Levelitem = ({ index, details }: levelitemProps) => {
	return (
		<div className='bg-appcolorpinkdeepone rounded-[5px] p-4 relative mb-4 cursor-pointer'>
			<div className='flex items-center text-base leading-[26px] font-semibold '>
				<p className='text-appcolorblack mr-[0.5rem]'>Module {index + 1}:</p>
				<p className='text-appcolorgreyfaintfour'>{details.title}</p>
			</div>


			<div className='flex items-center text-base leading-[26px] font-semibold '>
				<p className='text-appcolorblack mr-[0.5rem]'>Module Type:</p>
				<p className='text-appcolorgreyfaintfour'>{details.typeModel.toUpperCase()}</p>
			</div>
		</div>
	)
}

export default Levelitem